import React from 'react'

import Container from '../Container/Container'

const GenericError: React.FC = (): React.ReactElement => {
  return (
    <Container>
      <h1>Something went wrong</h1>
      <p>
        We're a little bit lost. <a href="/">Click here</a> to return to go to
        the login page.
      </p>
    </Container>
  )
}

export default GenericError
